"use client"

import React, { useEffect, useState } from "react"
import { Table } from "antd"
import { FolderOutlined, FileOutlined } from "@ant-design/icons"
// interface TrackUnitType {
//   asset_class: string
//   asset_class_clean: string
//   total_impact: string | number | null
//   daily_temp_calculated: number | null
//   summer_temperature_calculated: number | null
//   max_rainfall_calculated: number | null
//   winter_rainfall_calculated: number | null
//   summer_rainfall_calculated: number | null
//   flooding_calculated: number | null
//   erosion_calculated: number | null
//   children?: TrackUnitType[]
// }

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    render: (text, i) => (
      <div style={{ fontWeight: "bold" }}>
        {i.children && <FolderOutlined />}{" "}
        {!i.children && (
          <a href={text} target="_blank" rel="noopener noreferrer">
            <FileOutlined /> {text}
          </a>
        )}
        {i.children && text}
      </div>
    ),
    width: 1000,
  },
]

const trackUnits = [
  {
    name: "Local Authorities",
    link: "#",
    children: [
      {
        name: "Other",
        link: "#",
        children: [
          {
            name: "epping_forest_sample.xlsx",
            link: "#",
          },
          {
            name: "Harlow.pptx",
            link: "#",
          },
          {
            name: "Maldon.pdf",
            link: "#",
          },
          {
            name: "Rochford.mp4",
            link: "#",
          },
        ],
      },
      {
        name: "Braintree.pdf",
        link: "#",
      },
      {
        name: "Brentwood.pdf",
        link: "#",
      },
      {
        name: "Castle_Point.pdf",
        link: "#",
      },
    ],
  },
  {
    name: "Air Quality Management Areas",
    link: "#",
    children: [
      {
        name: "AQMA 1",
        link: "#",
      },
      {
        name: "AQMA 2",
        link: "#",
      },
      {
        name: "AQMA 3",
        link: "#",
      },
      {
        name: "AQMA 4",
        link: "#",
      },
    ],
  },
  {
    name: "Air Quality Resources",
    link: "#",
    children: [
      {
        name: "Health and Air Pollution in Essex",
        link: "#",
      },
      {
        name: "Alternative Transport in Essex",
        link: "#",
      },
      {
        name: "Air Quality in Essex",
        link: "#",
      },
      {
        name: "Air Quality in the UK",
        link: "#",
      },
    ],
  },
  {
    name: "Diffusion Tube Data",
    link: "#",
    children: [
      {
        name: "Three Rivers",
        link: "#",
      },
      {
        name: "Angle Valley",
        link: "#",
      },
      {
        name: "Berent",
        link: "#",
      },
      {
        name: "Fordham",
        link: "#",
      },
    ],
  },
]

const CustomCell = (props, i) => {
  // console.log("Cell props:", props, i)
  return (
    // <Tooltip title="some info">
    <td {...props} />
    // </Tooltip>
  )
}

export default function DownloadTable(props) {
  const { id } = props

  const [data, setData] = useState([])

  useEffect(() => {
    const getInfo = async () => {
      // const output = await getCCRA("id", "token")
      // setData(output)
    }
    getInfo()
  }, [])

  return (
    <>
      <div style={{ margin: "20px", boxSizing: "border-box" }}>
        <div style={{ width: "100%" }}>
          <h2>Resources & Downloads</h2>
          <Table
            style={{ width: "100%" }}
            rowKey="name"
            indentSize={25}
            columns={columns}
            dataSource={trackUnits}
            pagination={false}
            components={{
              body: {
                cell: CustomCell,
              },
            }}
          />
        </div>
      </div>
    </>
  )
}
